import { api } from '@infl-ts/util-hub-axios-instance';
import { both } from '@infl-ts/util-io-ts';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import * as t from 'io-ts';
import { HUB_PUSHER_CLUSTER, HUB_PUSHER_KEY } from '../env';
var AuthDataType = both({
  auth: t.string
}, {
  channel_data: t.string,
  shared_secret: t.string
});

var authWithAxios = function authWithAxios(_ref) {
  var channel = _ref.channel,
      socketId = _ref.socketId;
  return api.request({
    method: 'POST',
    url: '/pusher/auth',
    params: {
      channel_name: channel.name,
      socket_id: socketId
    }
  });
};

export var pusher = pipe(function () {
  return import('pusher-js/with-encryption');
}, T.map(function (x) {
  return x["default"];
}), T.map(E.tryCatchK(function (Pusher) {
  return new Pusher(HUB_PUSHER_KEY, {
    cluster: HUB_PUSHER_CLUSTER,
    authEndpoint: '/pusher/auth',
    authorizer: function authorizer(channel) {
      return {
        authorize: function authorize(socketId, callback) {
          return void pipe(authWithAxios({
            channel: channel,
            socketId: socketId
          }), TE.chainEitherKW(flow(function (response) {
            return AuthDataType.decode(response.data);
          }, E.mapLeft(makeDecodeError))), TE.mapLeft(function (error) {
            return Error("Failed to authorize pusher: ".concat(JSON.stringify(error)));
          }), T.chainIOK(E.match(function (error) {
            return function () {
              return callback(error, {
                auth: ''
              });
            };
          }, function (data) {
            return function () {
              return callback(null, data);
            };
          })))();
        }
      };
    }
  });
}, function (e) {
  return Error("There was an error creating a Pusher instance: ".concat(JSON.stringify(e)));
})));